module.exports = __webpack_public_path__ + "img/121.e6479916.svg";